"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InitialsHolder = exports.BaseAvatar = exports.sizeValue = exports.Size = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledSystem = require("styled-system");

var _color = require("../../helpers/color");

var _primitives = require("../../platform/primitives");

var _Flex = require("../Flex");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  text-align: center;\n  overflow: hidden;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/** Size */
var Size = {
  xxs: {
    diameter: "30px",
    typeSize: "3"
  },
  xs: {
    diameter: "45px",
    typeSize: "3"
  },
  sm: {
    diameter: "70px",
    typeSize: "6"
  },
  md: {
    diameter: "100px",
    typeSize: "8"
  }
};
exports.Size = Size;

/** sizeValue */
var sizeValue = function sizeValue(size) {
  switch (size) {
    case "xxs":
      return Size.xxs;

    case "xs":
      return Size.xs;

    case "sm":
      return Size.sm;

    case "md":
    default:
      return Size.md;
  }
};

exports.sizeValue = sizeValue;

/** An circular Avatar component containing an image or initials */
var BaseAvatar = function BaseAvatar(_ref) {
  var src = _ref.src,
      initials = _ref.initials,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      renderAvatar = _ref.renderAvatar;

  var _sizeValue = sizeValue(size),
      diameter = _sizeValue.diameter,
      typeSize = _sizeValue.typeSize;

  if (src) {
    return renderAvatar();
  } else if (initials) {
    // Left align for overflow
    var justifyContent = initials.length > 4 ? "left" : "center";
    return _react.default.createElement(InitialsHolder, {
      width: diameter,
      height: diameter,
      justifyContent: justifyContent,
      alignItems: "center" // NOTE: To make a circle in React Native:
      // you have to use a numeric value and can't use "50%"
      ,
      borderRadius: diameter
    }, _react.default.createElement(_Typography.Sans, {
      size: typeSize,
      color: "black60",
      weight: "medium",
      lineHeight: parseInt(diameter, 10)
    }, initials));
  } else {
    return null;
  }
};
/** InitialsHolder */


exports.BaseAvatar = BaseAvatar;
var InitialsHolder = (0, _primitives.styledWrapper)(_Flex.Flex)(_templateObject(), (0, _color.color)("black10"), _styledSystem.borderRadius);
exports.InitialsHolder = InitialsHolder;
InitialsHolder.displayName = "InitialsHolder";
//# sourceMappingURL=Avatar.shared.js.map